import listingMapAdapter from '@/features/listing/requests/adapters/listing-map-adapter';
import { type ListingMapFeatureCollection } from '@/features/listing/types/listing-types';
import { type ListingsMapSearchResponse } from '@/features/listing/types/listings-search-response-types';
import sendHttpError from '@/libs/logger/requests/send-http-error';

export default async function getMapListings(
  searchParams: string,
  currentCurrencyName: string,
  bearerToken?: string | null,
): Promise<ListingMapFeatureCollection> {
  const headers: HeadersInit = { Currency: currentCurrencyName };
  const url = `${process.env.NEXT_PUBLIC_API_URL}/v1/search?${searchParams}`;

  if (bearerToken) {
    headers.Authorization = `Bearer ${bearerToken}`;
  }

  const mapListingsResponse = await fetch(url, {
    cache: 'no-store',
    headers,
  });

  if (!mapListingsResponse.ok) {
    sendHttpError({
      baseName: 'Get listings for map',
      functionName: 'getMapListings',
      method: 'GET',
      requestHeaders: headers,
      statusCode: mapListingsResponse.status,
      url,
    });

    throw new Error('Failed to fetch map listings');
  }

  const mapListingsData = await mapListingsResponse.json() as ListingsMapSearchResponse[];

  return {
    features: mapListingsData.map((mapListing) => listingMapAdapter(mapListing)),
    type: 'FeatureCollection',
  };
}
